import React, { useEffect } from "react";
import { assetIdToProductType } from "../imports";
import { useSelector, useDispatch } from "react-redux";
import { getSelectedNodeData } from "../redux/creators/playerCreators";
import { testImage } from "../redux/creators/threekitCreators";

export default function ThreekitReconciler({
  border,
  depth,
  frame,
  posterBorder,
  paperType,
}) {
  const { assetId, imageMagickObj, selectedNodeData } = useSelector(
    (state) => ({
      assetId: state.threekit.assetId,
      imageMagickObj: state.playerState.imageMagickObj,
      selectedNodeData: getSelectedNodeData(state),
    })
  );
  const borderAssetMap = {
    Black: "63ccea68-4d3b-4637-9fca-962147956e89",
    Grey: "43b9d81e-1d81-4b67-9b7b-83737fcbcc53",
    White: "1f779f81-c495-4c40-b186-9b82aedc2a7a",
    Mirror: "efdd80a1-6e0e-4a5e-9666-7352769432a3",
    Blur: "35baefef-b860-434a-a1e3-4a8569507149",
  };

  const frameAssetMap = {
    black: "b4ed77ee-44ec-4f54-b115-93a2b99c8eda",
    gold: "c4975285-a10d-457f-a5ab-d1dc5bb521f3",
    white: "f43bced3-f475-4cc3-891d-dc831a928152",
    natural: "c7b8cefc-eea1-477c-a563-0b6ce8d61bb7",
    espresso: "bb94b433-e39f-4105-b250-2e503de94092",
  };

  const posterBorderAssetMap = {
    1: "384129b0-b205-4ecc-b9a0-a7d5ed46671e",
    0: "065f5ead-6e35-4016-9f91-fc452444ac7f",
    F: "76e75bde-1ca8-4e84-849a-948feb91bcb4",
  };

  const paperTypeAssetMap = {
    Semi: "87397c36-36e8-4c65-88b8-a51d7dce4edd",
    Glossy: "71346312-d1ae-4649-9940-72d6ab672d60",
    Matte: "50eb0c8e-b89c-4af8-8ff2-e91552630982",
  };

  const productType = assetIdToProductType(assetId);
  function handleMultipleProductChange() {
    const configurator =
      selectedNodeData?.configurator || window.configuratorobj;
    if (selectedNodeData && configurator) {
      const {
        horizontalPos,
        verticalPos,
        rotate,
        imageHeight,
        imageWidth,
        blacknwhite,
      } = selectedNodeData;
      const newConfiguration = {};
      if (horizontalPos) {
        newConfiguration.canvas_horizontal_global = horizontalPos;
      }
      if (verticalPos) {
        newConfiguration.canvas_vertical_global = verticalPos;
      }
      if (rotate) {
        newConfiguration.canvas_rotation_global = rotate;
      }
      if (imageHeight) {
        newConfiguration.image_height = imageHeight;
        newConfiguration.image_width = imageWidth;
      }
      newConfiguration.blackwhite_global = !!blacknwhite;
      configurator.setConfiguration(newConfiguration);
    }
  }

  function handleSingleProductChange() {
    const {
      rotate,
      imageHeight,
      imageWidth,
      horizontalPos,
      verticalPos,
      imageposHorizontal,
      imageposVertical,
      blacknwhite,
    } = imageMagickObj;
    const newConfiguration = {};
    if (productType === "triptych") {
      newConfiguration["panelName"] = { assetId };
      newConfiguration.imageposHorizontal = imageposHorizontal;
      newConfiguration.imageposVertical = imageposVertical;
      newConfiguration.blackwhite_global = blacknwhite;
      newConfiguration.image_height = imageHeight;
      newConfiguration.image_width = imageWidth;
    } else {
      newConfiguration.canvas_rotation_global = rotate;
      newConfiguration.image_height = imageHeight;
      newConfiguration.image_width = imageWidth;
      newConfiguration.canvas_horizontal_global = horizontalPos;
      newConfiguration.canvas_vertical_global = verticalPos;
      newConfiguration.blackwhite_global = blacknwhite;
      newConfiguration["BorderSize"] = depth.split(" (")[0];
      newConfiguration["Border"] = {
        assetId: borderAssetMap[border.split(" (")[0]],
      };
      if (frame != undefined && frame != "barnwood") {
        newConfiguration["Custom_Frame_Color"] = {
          assetId: frameAssetMap[frame],
        };
        newConfiguration["Show_Frame"] = "Yes";
      } else {
        newConfiguration["Show_Frame"] = "No";
      }
      newConfiguration["Poster_Border"] = {
        assetId: posterBorderAssetMap[posterBorder.charAt(0)],
      };
      newConfiguration["PosterFinish"] = {
        assetId: paperTypeAssetMap[paperType.split("-")[0]],
      };
    }
    window.configurator.setConfiguration(newConfiguration);
  }

  const cleanedNodeData = { ...selectedNodeData };
  cleanedNodeData.configurator && delete cleanedNodeData.configurator;
  useEffect(() => {
    if (!window.configurator?.setConfiguration) {
      return;
    } else if (productType === "collage" || productType == "wall-display") {
      handleMultipleProductChange();
    } else {
      handleSingleProductChange();
    }
  }, [
    JSON.stringify(imageMagickObj),
    JSON.stringify(cleanedNodeData),
    border,
    depth,
    frame,
    posterBorder,
    paperType,
  ]);

  const dispatch = useDispatch();
  function testUpload() {
    dispatch(testImage());
  }

  return <div id="reconciler" onClick={testUpload}></div>;
}
